import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { BookingComponentLoadable, BookingTableComponentLoadable } from '../BookingComponent'
import LoadingComponent from '../CommonComponent/LoadingComponent'
import NotFoundComponent from '../CommonComponent/NotFoundComponent'
import AppLayout from '../Layout/AppLayout'
import { LoginComponent } from "../LoginComponent"
import { DailyRecapReportLoadable, CustomerReportComponentLoadable, LifeScienceReportComponentLoadable } from '../ReportComponent'
import ProtectedRoute from './ProtectRoutes'
import { PodFilesTableComponentLoadable } from '../PodFilesComponent'
import { ShipperTableComponentLoadable, ConsigneeTableComponentLoadable } from '../MasterComponent'
import { OdaRatesTableComponentLoadable } from '../OdaReatesComponent'

const AppRoutes = () => {

    return (
        <Suspense fallback={<LoadingComponent />}>
            <Routes>
                <Route path='/' element={
                    <ProtectedRoute>
                        <AppLayout />
                    </ProtectedRoute>
                }>
                    <Route path='booking' element={
                        <BookingTableComponentLoadable />
                    } />
                    <Route path='add-booking' element={
                        <BookingComponentLoadable />
                    } />
                    <Route path='booking/:id' element={
                        <BookingComponentLoadable />
                    } />
                    <Route path='report' element={
                        <DailyRecapReportLoadable />
                    } />
                    <Route path='customer-report' element={
                        <CustomerReportComponentLoadable />
                    }
                    />
                    <Route path='life-science-report' element={
                        <LifeScienceReportComponentLoadable />
                    }
                    />
                    <Route path='pod-files' element={
                        <PodFilesTableComponentLoadable />
                    } />
                    <Route path='oda-rates' element={
                        <OdaRatesTableComponentLoadable />
                    } />
                    <Route path='shippers' element={
                        <ShipperTableComponentLoadable />
                    } />
                    <Route path='consignee' element={
                        <ConsigneeTableComponentLoadable />
                    } />
                    <Route path="/" element={<LoginComponent />} />
                    <Route path="*" element={<NotFoundComponent />} />

                </Route>
            </Routes >
        </Suspense>

    )
}

export default AppRoutes